import { Stack } from "@biggeo/bg-ui/lab";
import { map } from "fp-ts/Array";
import { pipe } from "fp-ts/function";
import { MapContextDataset } from "../../map/mapbox/context/types";
import { Routes } from "../../navigation/redux/model";
import DataSampleCardContainer from "../containers/DataSampleCardContainer";
import DataSampleBanner from "./DataSampleBanner";
import { setDatasetContext } from "../../map/mapbox/context/utils/general-utils";

interface IDataSampleDatasets {
    readonly samples: MapContextDataset[];
}

const DataSampleDatasets = ({ samples }: IDataSampleDatasets) => {
    const { updateDataset } = setDatasetContext();

    const onSwitchClick = (i: {
        dataSourceId: string;
        isSelected: boolean;
    }) => {
        const { dataSourceId, isSelected } = i;

        updateDataset({
            dataSourceId,
            dataset: {
                isSelected,
                isVisible: isSelected,
            },
        });
    };

    const onBuyNowClick = (fkMarketplaceDatasetId: string) => {
        window.open(
            `${Routes.marketplace}/datasets/${fkMarketplaceDatasetId}/pricing-options`,
            "_blank"
        );
    };

    const onContactSalesClick = (fkMarketplaceDatasetId: string) => {
        window.open(
            `${Routes.marketplace}/datasets/${fkMarketplaceDatasetId}/contact-sales`,
            "_blank"
        );
    };

    return (
        <Stack
            gap={4}
            sx={{
                padding: 4,
            }}
        >
            {pipe(
                samples,
                map((sample) => (
                    <DataSampleCardContainer
                        key={sample.dataSource.id}
                        sample={sample}
                        onSwitchClick={onSwitchClick}
                        onBuyNowClick={onBuyNowClick}
                        onContactSalesClick={onContactSalesClick}
                    />
                ))
            )}
            <DataSampleBanner />
        </Stack>
    );
};

export default DataSampleDatasets;
